import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const ReportSectionRoot = superstyled({
  name: 'ReportSection',
  slot: 'Root',
  tag: Box,
  propsNeeded: ['isBubble'],
  styles: ({ theme, isBubble }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.border.main}`,
    backgroundColor: isBubble ? '#E1EBFF' : 'transparent',
    borderRadius: theme.shape.borderRadius * (isBubble ? 1 : 0),
    padding: theme.spacing(isBubble ? 3 : 0),
    marginBottom: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(2),
      padding: theme.spacing(isBubble ? 3 : 0, isBubble ? 3 : 0)
    }
  })
});

export const SectionHeader = superstyled({
  name: 'ReportSection',
  slot: 'Header',
  tag: Box,
  propsNeeded: ['isBubble'],
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: theme.spacing(2)
  })
});

export const SectionTitleRow = superstyled({
  name: 'ReportSection',
  slot: 'TitleRow',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(0.5)
  })
});

export const SectionIcon = superstyled({
  name: 'ReportSection',
  slot: 'Icon',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(4),
    height: theme.spacing(4),
    minWidth: theme.spacing(4),
    borderRadius: theme.shape.borderRadius * 0.5,
    background: '#D1FDFF',
    color: '#3971E7',
    '& svg': {
      fontSize: theme.spacing(2.5)
    }
  })
});

export const SectionTitle = superstyled({
  name: 'ReportSection',
  slot: 'Title',
  tag: Text,
  styles: ({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary
  })
});

export const SectionTitleSection = superstyled({
  name: 'ReportSection',
  slot: 'TitleSection',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1.5)
  })
});

export const CostRange = superstyled({
  name: 'ReportSection',
  slot: 'CostRange',
  tag: Text,
  styles: ({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    textAlign: 'right'
  })
});

export const SectionContent = superstyled({
  name: 'ReportSection',
  slot: 'Content',
  tag: Box,
  propsNeeded: ['isBubble'],
  styles: ({ theme, isBubble = false }) => ({
    lineHeight: 1.6,
    color: theme.palette.text.secondary,
    paddingLeft: isBubble ? 0 : theme.spacing(5.5),
    marginBottom: theme.spacing(isBubble ? 0 : 2.5),
    '& ul': {
      margin: 0,
      paddingLeft: theme.spacing(2)
    },
    '& li': {
      marginBottom: theme.spacing(0.5)
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0
    }
  })
});
